/* eslint-disable no-case-declarations */
//@ts-check
import logger from './logger'

// based on password score number, provide a human friendly message describing password strength
function getFriendlyPasswordScoreName(scoreInt) {
    const passwordScoreMap = {
        0: 'very weak',
        1: 'weak',
        2: 'medium',
        3: 'strong',
        4: 'very strong',
    }

    return passwordScoreMap[scoreInt]
}

function containsSpecialChars(str) {
    // Regular expression to match special characters, letters and numbers
    const specialChars = /^(?=.*[a-zA-Z])(?=.*\d)(?=.*[!@#$%^&*()_+{}\[\]:;"'`~<>,.?\\/-]).+$/

    // Check if the string contains any special characters
    return specialChars.test(str)
}

export async function passwordStrengthChecker(shouldValidate) {
    // traversing the DOM and getting the input and span using their IDs

    // Adding an input event listener when a user types to the  password input
    try {
        // https://github.com/dropbox/zxcvbn
        const zxcvbn = (await import('zxcvbn')).default
        logger.trace('Lazy loaded zxcvbn: password strength checker')

        const passwordField =
            document.getElementById('password') || document.querySelector('[data-name="password"]')
        const strengthBadge = document.getElementById('passwordStr')

        if (strengthBadge && passwordField) {
            passwordField.addEventListener('input', () => {
                const passwordValue = passwordField.value
                const passwordTestResult = zxcvbn(passwordValue)
                // const friendlyFormattedTimeToHack = passwordTestResult.crack_times_display.online_no_throttling_10_per_second;
                const score = passwordTestResult.score

                const doesPasswordContainMin8Chars = passwordValue.length >= 8
                const doesPasswordContainSpecialChar = containsSpecialChars(passwordValue)

                strengthBadge.classList.add('visible')
                strengthBadge.innerHTML = `<div class="password-attr-strength">Password strength: <strong>${getFriendlyPasswordScoreName(score)}</strong></div>
                <div class='password-attr-${doesPasswordContainMin8Chars ? 'success' : 'failure'}'>At least 8 characters</div>
                <div class='password-attr-${doesPasswordContainSpecialChar ? 'success' : 'failure'}'>1 special, 1 letter, 1 number</div>
                `
                //The badge is hidden by default, so we show it
                //We then call the StrengChecker function as a callback then pass the typed password to it
                //Incase a user clears the text, the badge is hidden again
                if (passwordField.value.length !== 0) {
                    strengthBadge.classList.add('visible')
                } else {
                    strengthBadge.classList.remove('visible')
                }
            })
        }
    } catch (error) {
        logger.error(error)
    }
}
